import React from 'react';
export function CostComparison() {
  return <section className="py-14 bg-white" data-id="element-72">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-73">
        <div className="text-center mb-8" data-id="element-74">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-dark mb-3" data-id="element-75">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-200 mb-8" data-id="element-76">
          <div className="overflow-x-auto" data-id="element-77">
            <table className="w-full text-left border-collapse" data-id="element-78">
              <thead data-id="element-79">
                <tr className="bg-gray-50 text-brand-dark" data-id="element-80">
                  <th className="p-3 md:p-4 font-bold w-1/2 border-b border-gray-200" data-id="element-81">
                    Sin Miga Master Pro
                  </th>
                  <th className="p-3 md:p-4 font-bold w-1/2 border-b border-l border-gray-200 text-brand-red" data-id="element-82">
                    Costo real
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-83">
                <tr className="hover:bg-gray-50" data-id="element-84">
                  <td className="p-3 md:p-4 text-brand-dark" data-id="element-85">
                    Sándwiches que se secan en 2 horas
                  </td>
                  <td className="p-3 md:p-4 text-brand-red font-medium border-l border-gray-200" data-id="element-86">
                    Clientes que no vuelven
                  </td>
                </tr>
                <tr className="hover:bg-gray-50" data-id="element-87">
                  <td className="p-3 md:p-4 text-brand-dark" data-id="element-88">
                    Precios calculados a ojo
                  </td>
                  <td className="p-3 md:p-4 text-brand-red font-medium border-l border-gray-200" data-id="element-89">
                    Trabajás mucho y ganás poco
                  </td>
                </tr>
                <tr className="hover:bg-gray-50" data-id="element-90">
                  <td className="p-3 md:p-4 text-brand-dark" data-id="element-91">
                    Sin guiones de venta
                  </td>
                  <td className="p-3 md:p-4 text-brand-red font-medium border-l border-gray-200" data-id="element-92">
                    Perdés el 60% de las consultas
                  </td>
                </tr>
                <tr className="hover:bg-gray-50" data-id="element-93">
                  <td className="p-3 md:p-4 text-brand-dark" data-id="element-94">
                    Sin calculadora de costos
                  </td>
                  <td className="p-3 md:p-4 text-brand-red font-medium border-l border-gray-200" data-id="element-95">
                    Regalás tu tiempo sin saberlo
                  </td>
                </tr>
                <tr className="hover:bg-gray-50" data-id="element-96">
                  <td className="p-3 md:p-4 text-brand-dark" data-id="element-97">
                    Sin sistema para eventos grandes
                  </td>
                  <td className="p-3 md:p-4 text-brand-red font-medium border-l border-gray-200" data-id="element-98">
                    Rechazás pedidos que podrías hacer
                  </td>
                </tr>
                <tr className="hover:bg-gray-50" data-id="element-99">
                  <td className="p-3 md:p-4 text-brand-dark" data-id="element-100">
                    Fin de semana cocinando sin sistema
                  </td>
                  <td className="p-3 md:p-4 text-brand-red font-medium border-l border-gray-200" data-id="element-101">
                    El mismo ciclo, el próximo mes
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="text-center" data-id="element-102">
          <h3 className="text-2xl md:text-3xl font-serif font-bold text-brand-gold" data-id="element-103">
            El próximo pedido puede cambiarlo todo.
          </h3>
        </div>
      </div>
    </section>;
}